<template>
    <div id="basicInfo">
        <my-header></my-header>
        <div class="banner">
            <img src="../../assets/images/register/bg.jpg"/>
        </div>
        <div class="main-container basicMain">
           <!-- <el-steps  :active="stepActive" finish-status="success" align-center>
                <el-step title="注册"></el-step>
                <el-step title="审核中"></el-step>
                <el-step title="成功入库"></el-step>
            </el-steps>-->
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="基本情况" name="0">
                    <div id="register">
                        <section class="small-container" style="box-shadow: 0 0 2px; height:20px" v-show="baseForm.supplierStatus== 1 ">
                            <div style="color:red;float:left;margin-left:5px;line-height:30px">审核退回理由:<span>{{baseForm.checkReason||'无'}}</span></div>
                        </section>
                        <!-- 基本信息 -->
                        <section class="small-container">
                            <h3>基础信息<span class="tips">请先提交"基础信息"后再完成其他页面 | 带*的必须填写</span></h3>
                            <el-form
                                :disabled="editFlage == 0"
                                :label-position="labelPosition"
                                :model="baseForm"
                                :rules="baseRules"
                                status-icon
                                :inline-message="false"
                                ref="baseForm"
                                label-width="180px"
                                class="baseForm">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="供方名称：" prop="companyName">
                                            <el-input  id="companyName" class="redMark" size="mini" v-model.trim="baseForm.companyName"  placeholder="需与企业工商注册信息一致" :maxlength="50"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                    <el-form-item label="垄断类：" prop="monopolyFlag">
                                                <el-radio-group id="monopolyFlag"  class="redMark" disabled v-model.trim="baseForm.monopolyFlag">
                                                    <el-radio :label="0" id="isLongduanM">是</el-radio>
                                                    <el-radio :label="1" id="isLongduannoM">否</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="社会信用代码：" prop="socialCreditCode" >
                                            <el-input id="socialCreditCode" @change="checkSocialCode(baseForm.socialCreditCode)" class="redMark" clearable size="mini"  v-model.trim="baseForm.socialCreditCode" :maxlength="18" type="text" placeholder="供应商唯一性验证，登录账号"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="可投标地域：" prop="biddingArea">
                                            <el-input id="biddingArea" class="redMark" clearable size="mini"  v-model.trim="baseForm.biddingArea" :maxlength="18" type="text" placeholder="全国/上海"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                    <el-form-item label="是否有上级单位：" prop="superiorFlag" >
                                                <el-radio-group id="superiorFlag"   class="redMark" v-model.trim="baseForm.superiorFlag" @change="changeSuperiorFlag()">
                                                    <el-radio :label="0" id="yesM">是</el-radio>
                                                    <el-radio :label="1" id="noM">否</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="上级单位名称：" prop="superiorCompanyName" :rules="{required: baseForm.superiorFlag == 0, message: ' ',trigger:'blur'}">
                                            <el-input :disabled="baseForm.superiorFlag==1" id="superiorCompanyName" class="redMark" clearable size="mini"  v-model.trim="baseForm.superiorCompanyName" :maxlength="18" type="text" placeholder="***公司（***地产）"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="国家：" prop="countryName" >
                                            <el-input  id="countryName" clearable size="mini"  v-model.trim="baseForm.countryName" :maxlength="18" type="text" placeholder="中国"></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="12">
                                        <el-form-item label="城市：" prop="cityName" >
                                            <el-input   id="cityName" clearable size="mini"  v-model.trim="baseForm.cityName" :maxlength="18" type="text" placeholder="上海"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="联系人：" prop="linkMan" :rules="{required: baseForm.monopolyFlag == 1, message:' ', trigger:'blur'}">
                                            <el-input   clearable :maxlength="50" class="redMark" v-model.trim="baseForm.linkMan" size="mini" placeholder="张*"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="职务："  prop="linkManPost" :rules="{required: baseForm.monopolyFlag == 1, message:' ', trigger:'blur'}">
                                            <el-input   clearable :maxlength="50" class="redMark" v-model.trim="baseForm.linkManPost" size="mini" placeholder="*经理"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="联系电话：" prop="linkPhone" :rules="{required: baseForm.monopolyFlag == 1, message:' ', trigger:'blur'}">
                                            <el-input   clearable @change="checkPhone(baseForm.linkPhone,1)" :maxlength="50" class="redMark" v-model.trim="baseForm.linkPhone" size="mini" placeholder="13********1"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="推荐人：" prop="recommender" :rules="{required: false, message:' ', trigger:'blur'}">
                                            <el-input   clearable :maxlength="50" class="redMark" v-model.trim="baseForm.recommender" size="mini" placeholder="张*"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="办公地址：" prop="headquartersAddress" :rules="{required: baseForm.monopolyFlag == 1, message:' ', trigger:'blur'}">
                                            <el-input   clearable :maxlength="50" class="redMark" v-model.trim="baseForm.headquartersAddress" size="mini" placeholder="**省**市**路**号**幢**室"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="公司邮箱：" prop="companyEmail" :rules="{required: baseForm.monopolyFlag == 1, message:' ', trigger:'blur'}">
                                            <el-input   clearable @change="checkEmail(baseForm.companyEmail)" :maxlength="50" class="redMark" v-model.trim="baseForm.companyEmail" size="mini" placeholder="123@qq.com"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <!-- 企业资质 -->
                        <section class="small-container">
                            <h3>企业资质</h3>
                            <el-form :model="baseForm" :label-position="labelPosition" status-icon :inline-message="false" ref="qiYeZiZhiForm" label-width="180px" class="baseForm"
                            :disabled="editFlage == 0"
                            >
                                <el-row>
                                    <el-col :span="12">
                                    <el-form-item label="是否有独立资质：" prop="qualificationsFlag">
                                                <el-radio-group id="qualificationsFlag"   class="redMark" v-model.trim="baseForm.qualificationsFlag">
                                                    <el-radio :label="0" id="yesM">是</el-radio>
                                                    <el-radio :label="1" id="noM">否</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="企业资质：" prop="enterpriseQualification" :rules=" {required: baseForm.qualificationsFlag==0, message: ' ',trigger:'blur'}">
                                            <el-input   clearable id="enterpriseQualification" class="redMark" size="mini" v-model.trim="baseForm.enterpriseQualification" type="text" :maxlength="18" placeholder="A级"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="企业资质证书编号：">
                                            <el-input   clearable id="qualificationCertificate" class="redMark" size="mini" v-model.trim="baseForm.qualificationCertificate" type="text" :maxlength="18" placeholder="请输入..."></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="资质审核到期日：">
                                            <el-date-picker  size="mini" type="date"
                                                                id="qualificationReviewTime"
                                                                class="redMark"
                                                                :editable="false"
                                                                 
                                                                :picker-options="$root.pickerOptions"
                                                                format="yyyy-MM-dd"
                                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                                placeholder="选择日期"
                                                                v-model="baseForm.qualificationReviewTime">
                                                </el-date-picker>
                                        <!--  <el-input  clearable id="qualificationReviewTime" class="redMark" size="mini" v-model.trim="baseForm.qualificationReviewTime " type="text" :maxlength="18" placeholder="请输入..."></el-input> -->
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="安全许可证到期日：">
                                            <el-date-picker  size="mini" type="date"
                                                                id="validityPeriodOfLicense"
                                                                class="redMark"
                                                                :editable="false"
                                                                 
                                                                :picker-options="$root.pickerOptions"
                                                                format="yyyy-MM-dd"
                                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                                placeholder="选择日期"
                                                                v-model="baseForm.validityPeriodOfLicense">
                                                </el-date-picker>
                                            <!-- <el-input  clearable id="validityPeriodOfLicense" class="redMark" size="mini" v-model.trim="baseForm.validityPeriodOfLicense " type="text" :maxlength="18" placeholder="请输入..."></el-input> -->
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="企业认证：">
                                            <el-input   clearable id="enterpriseCertification" class="redMark" size="mini" v-model.trim="baseForm.enterpriseCertification" type="text" :maxlength="18" placeholder="请输入..."></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <!-- 注册信息 -->
                        <section class="small-container">
                            <h3>注册信息</h3>
                            <el-form
                                :disabled="editFlage == 0"
                                :label-position="labelPosition"
                                :model="baseForm"
                                status-icon
                                :rules="registerRules"
                                :inline-message="false"
                                ref="registerForm"
                                label-width="180px"
                                class="baseForm">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="企业法人：" prop="legalRepresentative">
                                            <el-input   id="legalRepresentative" class="redMark" size="mini" v-model.trim="baseForm.legalRepresentative"  placeholder="张*" :maxlength="50"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="注册资金（万元）：" prop="registeredCapital">
                                            <el-input   @change="checkRegisterNumberDotNew(baseForm.registeredCapital)" id="registeredCapital" class="redMark" size="mini" v-model.trim="baseForm.registeredCapital"  placeholder="9999.999999" :maxlength="50"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="企业性质：" prop="enterpriseNature">
                                            <el-select size="mini" class="redMark" v-model="baseForm.enterpriseNature" placeholder="请选择">
                                                <el-option
                                                    v-for="item in enterpriseNatureOptions"
                                                    :key="item.dictValue"
                                                    :label="item.dictLabel"
                                                    :value="item.dictValue">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="营业执照有效日期：" :rules="{required: baseForm.monopolyFlag == 1 ,message:' ', trigger:'change'}">
                                            <el-col :span="11" id="businessLicenseStartCol">
                                                <el-form-item prop="businessLicenseStart">
                                                    <el-date-picker  size="mini" type="date"
                                                                id="businessLicenseStart"
                                                                class="redMark"
                                                                :editable="false"
                                                                style='width: 130px;'
                                                                :picker-options="$root.pickerOptions"
                                                                format="yyyy-MM-dd"
                                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                                placeholder="开始时间"
                                                                v-model="baseForm.businessLicenseStart"
                                                                >
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col class="line" :span="2">-</el-col>
                                            <el-col :span="11">
                                                <el-form-item prop="businessLicenseValidity">
                                                    <el-date-picker  size="mini" type="date"
                                                                id="businessLicenseValidity"
                                                                class="redMark"
                                                                style='width: 130px;'
                                                                :editable="false"
                                                                :picker-options="$root.pickerOptions"
                                                                format="yyyy-MM-dd"
                                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                                placeholder="结束时间"
                                                                v-model="baseForm.businessLicenseValidity"
                                                                >
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="可开具发票性质：" prop="invoiceType">
                                            <el-select   size="mini" id="invoiceType" class="redMark" v-model="baseForm.invoiceType" placeholder="请选择" @change="changeInvoiceType()">
                                                <el-option
                                                    v-for="item in invoiceTypeOptions"
                                                    :key="item.dictValue"
                                                    :label="item.dictLabel"
                                                    :value="item.dictValue">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="税号：" prop="taxNumber">
                                            <el-input   id="taxNumber" class="redMark" size="mini" v-model.trim="baseForm.taxNumber"  placeholder="请输入..." :maxlength="50"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="注册地：" prop="enterpriseRegistAddress">
                                            <el-input   id="enterpriseRegistAddress" class="redMark" size="mini" v-model.trim="baseForm.enterpriseRegistAddress"  placeholder="**省**市**路**号**幢**室" :maxlength="50"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="可开具发票税率（%）：" prop="invoiceTaxRateList">
                                            <el-select   size="mini" id="invoiceTaxRateList" multiple collapse-tags class="redMark" v-model="baseForm.invoiceTaxRateList" placeholder="请选择" >
                                                <el-option
                                                    v-for="item in taxRateTypeOptions"
                                                    :key="item.dictValue"
                                                    :label="item.dictLabel"
                                                    :value="item.dictValue">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="纳税人规模：" prop="taxipayerStatus">
                                            <el-select  size="mini" id="taxipayerStatus" class="redMark" v-model="baseForm.taxipayerStatus" placeholder="请选择" @change="changeTaxipayerStatus()">
                                                <el-option
                                                    v-for="item in taxipayerOptions"
                                                    :key="item.dictValue"
                                                    :label="item.dictLabel"
                                                    :value="item.dictValue">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="企业经营范围：" prop="businessScope">
                                            <el-input   id="businessScope" type="textarea" :rows="2" placeholder="企业主营内容" v-model="baseForm.businessScope"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <!-- 供方分类 -->
                        <section class="small-container" id="category_container">
                            <h3>供方分类<span  v-if="editFlage == 1"  class="add" @click="addSupplierType"><img src="../../assets/images/register/btn02.png"/></span><span class="tipss" style="margin-right: 20px;">提示：请依次新增 | 带*的必须填写</span></h3>
                            <el-form class="naturalForm5" :rules="supplierTypeRules" ref="supplierTypeListRef" :model="supplierTypeListForm" :disabled="editFlage == 0">
                                <el-table :header-cell-style="{height:'5px',padding:'0px'}"
                                        :row-style="{height:'5px'}"
                                        :cell-style="{padding:'0px',font:'12px',height:'5px'}" border :data="supplierTypeListForm.supplierTypeList" style="width: 100%" >
                                    <el-table-column prop="categoryName"  label="供方分类" width="250">
                                        <template #header>
                                            <p class="naturalForm5Text">
                                            供方分类
                                            <span style="color:red;">*</span>
                                            </p>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form-item :prop="'supplierTypeList.' + scope.$index + '.categoryName'" :rules="supplierTypeRules.categoryName">
                                                <el-input  v-model="scope.row.categoryName"
                                                    readonly
                                                    autosize
                                                    style="width:100%"
                                                    type="textarea"
                                                    @focus="chooseCategory(scope.$index)"
                                                    suffix-icon="el-icon-search"
                                                    placeholder="选择供方分类"></el-input>
                                            </el-form-item>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="levelName"  label="供方资质等级（认证书资质全程）">
                                        <template #header>
                                            <p class="naturalForm5Text">
                                            供方资质等级（认证书资质全程）
                                            <span style="color:red;" v-if="baseForm.monopolyFlag==1">*</span>
                                            </p>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form-item v-if="baseForm.monopolyFlag==1" :prop="'supplierTypeList.' + scope.$index + '.levelName'" :rules="supplierTypeRules.levelName">
                                                <el-input v-model.trim="scope.row.levelName" placeholder="A级"  style="width:100%" :maxlength="50" clearable size="mini" ></el-input>
                                            </el-form-item>
                                            <el-form-item v-else :prop="'supplierTypeList.' + scope.$index + '.levelName'">
                                                <el-input v-model.trim="scope.row.levelName" placeholder="A级"  style="width:100%" :maxlength="50" clearable size="mini" ></el-input>
                                            </el-form-item>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="linkManPhone"  label="手机号码" width="180" >
                                        <template #header>
                                            <p class="naturalForm5Text">
                                            手机号码
                                            <span style="color:red;" v-if="baseForm.monopolyFlag==1">*</span>
                                            </p>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form-item v-if="baseForm.monopolyFlag==1" :prop="'supplierTypeList.' + scope.$index + '.linkManPhone'" :rules="supplierTypeRules.linkManPhone">
                                                <el-input @change="checkPhone(scope.row.linkManPhone,2,scope.$index)" v-model.trim="scope.row.linkManPhone" placeholder="13********1"  style="width:100%" :maxlength="50" clearable size="mini" ></el-input>
                                            </el-form-item>
                                            <el-form-item v-else :prop="'supplierTypeList.' + scope.$index + '.linkManPhone'">
                                                <el-input @change="checkPhone(scope.row.linkManPhone,2,scope.$index)" v-model.trim="scope.row.linkManPhone" placeholder="13********1"  style="width:100%" :maxlength="50" clearable size="mini" ></el-input>
                                            </el-form-item>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="linkMan"  label="联系人" width="180" >
                                        <template #header>
                                            <p class="naturalForm5Text">
                                            联系人
                                            <span style="color:red;" v-if="baseForm.monopolyFlag==1">*</span>
                                            </p>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form-item v-if="baseForm.monopolyFlag==1" :prop="'supplierTypeList.' + scope.$index + '.linkMan'" :rules="supplierTypeRules.linkMan">
                                                <el-input v-model.trim="scope.row.linkMan" placeholder="张*"  style="width:100%" :maxlength="50" clearable size="mini" ></el-input>
                                            </el-form-item>
                                            <el-form-item v-else :prop="'supplierTypeList.' + scope.$index + '.linkMan'">
                                                <el-input v-model.trim="scope.row.linkMan" placeholder="张*"  style="width:100%" :maxlength="50" clearable size="mini" ></el-input>
                                            </el-form-item>
                                        </template>
                                    </el-table-column>
                                    
                                    <el-table-column  label="操作" width="120" >
                                        <template #header>
                                            <p class="naturalForm5Text">
                                            操作
                                            </p>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form-item>
                                                <el-button v-if="scope.row.delFlag==1" style="width:100%" type="text" size="mini" @click="removeSupplierType(scope.$index)">删除</el-button>
                                            </el-form-item>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-form>
                        </section>
                        <!-- 近三年业绩 -->
                        <section class="small-container">
                            <h3>近三年业绩<span  v-if="editFlage == 1"  class="add" @click="addLastThreeAchieve"><img src="../../assets/images/register/btn02.png"/></span><span class="tipss" style="margin-right: 20px;">提示：请依次新增 | 带*的必须填写</span></h3>
                            <el-form v-if="!lastThreeAchieveList.length>0" :label-position="labelPosition" label-width="180px" class="naturalForm" :disabled="editFlage == 0">
                                <el-form-item label="近三年业绩：" >
                                    <span id="noneM" class="redMark">无</span>
                                    <span class="tip">（提示：若无业绩需要填写，请继续填写下方信息）</span>
                                </el-form-item>
                            </el-form>
                            <div v-else>
                                <el-form class="naturalForm5" :rules="lastThreeAchieveRules" ref="lastThreeAchieveFrom" :model="lastThreeAchieveForm" :disabled="editFlage == 0">
                                    <el-table :header-cell-style="{height:'5px',padding:'0px'}"
                                        :row-style="{height:'5px'}"
                                        :cell-style="{padding:'0px',font:'12px',height:'5px'}" border :data="lastThreeAchieveForm.lastThreeAchieveList" style="width: 100%" >
                                        <el-table-column prop="projectName"  label="项目名">
                                            <template slot="header">
                                                <p class="naturalForm5Text">
                                                项目名
                                                <span style="color:red;" v-if="baseForm.monopolyFlag==1">*</span>
                                                </p>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-form-item :prop="'lastThreeAchieveList.' + scope.$index + '.projectName'" :rules="lastThreeAchieveRules.projectName">
                                                    <el-input   v-model="scope.row.projectName" style="width:100%" :maxlength="50" clearable size="mini" placeholder="****市***地产***项目***工程"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="contractAmount"  label="合同金额（万元）" width="180">
                                            <template slot="header">
                                                <p class="naturalForm5Text">
                                                合同金额（万元）
                                                <span style="color:red;" v-if="baseForm.monopolyFlag==1">*</span>
                                                </p>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-form-item :prop="'lastThreeAchieveList.' + scope.$index + '.contractAmount'" :rules="lastThreeAchieveRules.contractAmount">
                                                    <el-input   v-model="scope.row.contractAmount" style="width:100%" :maxlength="50" clearable size="mini" placeholder="请输入数字..." @change="checkNumberDot(scope.$index,3,scope.row.contractAmount)"  ></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="projectAddress"  label="项目地" width="180">
                                            <template slot="header">
                                                <p class="naturalForm5Text">
                                                项目地
                                                <span style="color:red;" v-if="baseForm.monopolyFlag==1">*</span>
                                                </p>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-form-item :prop="'lastThreeAchieveList.' + scope.$index + '.projectAddress'" :rules="lastThreeAchieveRules.projectAddress">
                                                    <el-input   v-model="scope.row.projectAddress" style="width:100%" :maxlength="50" clearable size="mini" placeholder="请输入..."></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="contractSupplierName"  label="甲方名称" width="250">
                                            <template slot="header">
                                                <p class="naturalForm5Text">
                                                甲方名称
                                                <span style="color:red;" v-if="baseForm.monopolyFlag==1">*</span>
                                                </p>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-form-item :prop="'lastThreeAchieveList.' + scope.$index + '.contractSupplierName'" :rules="lastThreeAchieveRules.contractSupplierName">
                                                    <el-input   v-model="scope.row.contractSupplierName" style="width:100%" clearable size="mini" placeholder="***公司（***地产）"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                        <el-table-column  label="操作" width="120" >
                                            <template #header>
                                                <p class="naturalForm5Text">
                                                操作
                                                </p>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-form-item>
                                                    <el-button v-if="scope.row.delFlag==1||baseForm.monopolyFlag==0" style="width:100%" type="text" size="mini" @click="removeLastThreeAchieve(scope.$index)">删除</el-button>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-form>
                            </div>
                        </section>
                        <!-- 近三年财务情况 -->
                        <section class="small-container">
                            <h3> 近三年财务情况<span  v-if="editFlage == 1" class="add" @click="addLastThreeFinance"><img src="../../assets/images/register/btn02.png"/></span><span class="tipss" style="margin-right: 20px;">提示：请依次新增 | 带*的必须填写</span></h3>
                            <el-form v-if="!lastThreeFinanceList.length>0" :label-position="labelPosition" label-width="180px" class="naturalForm" :disabled="editFlage == 0">
                                <el-form-item label="近三年财务情况：" >
                                    <span id="noneM" class="redMark">无</span>
                                    <span class="tip">（提示：若无财务情况需要填写，请继续填写下方信息）</span>
                                </el-form-item>
                            </el-form>
                            <div v-else>
                                <el-form v-for="(lastThreeFinanceItem,index) in lastThreeFinanceList" :label-position="labelPosition" status-icon :inline-message="false" :key="index" 
                                :model="lastThreeFinanceItem" :rules="lastThreeFinanceRules" :ref="'lastThreeFinanceItem'+index" :id="'lastThreeFinanceItem'+index" class="naturalForm4"
                                :disabled="editFlage == 0">
                                    <el-row :gutter="15">
                                        <el-col :span="4">
                                            <el-form-item label="年度：" prop="year" label-width="60px" >
                                                <el-input
                                                    :id="'year' + index"
                                                    class="redMark"
                                                    clearable
                                                    :maxlength="50"
                                                    size="mini"
                                                    v-model.trim="lastThreeFinanceItem.year"
                                                    @change="checkNumber(index,2,lastThreeFinanceItem.year)"
                                                    placeholder="20**"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="7">
                                            <el-form-item label="主营业务收入（万元）：" prop="revenue" label-width="170px">
                                                <el-input   @change="checkNumberDot(index,1,lastThreeFinanceItem.revenue)" :id="'revenue' + index" class="redMark" :maxlength="50" clearable size="mini" v-model.trim="lastThreeFinanceItem.revenue" placeholder="9999.99"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12" id="attachmentCol">
                                            <el-form-item label="财务审计报告：" prop="attachmentVOList" label-width="170px">
                                                <page-upload :files="lastThreeFinanceItem.attachmentVOList"
                                                                :editFlag="true"
                                                                v-on:finishUpload="lastThreeFinanceItemFile()"
                                                                :attachmentType="index"></page-upload>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="1">
                                            <el-button v-if="(baseForm.monopolyFlag==0) || (index < lastThreeFinanceList.length-3 && baseForm.monopolyFlag==1)" @click="removeLastThreeFinance(index)" class="add dele" style="margin-top: -7px;" type="text"><img src="../../assets/images/register/icon_delete.png"/></el-button>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </div>
                        </section>
                        <!-- 银行信息 -->
                        <section class="small-container">
                            <h3> 银行信息</h3>
                            <el-form  :label-position="labelPosition" :rules="bankFormRules" status-icon :inline-message="false"  :model="bankForm"
                            :disabled="editFlage == 0"
                            ref="bankForm" label-width="180px"
                            class="bankForm">
                                <el-row :gutter="15">
                                    <el-col :span="12">
                                        <el-form-item label="国家：" prop="country" >
                                            <el-input id="country" class="redMark"   :maxlength="50" clearable size="mini" v-model.trim="bankForm.country" placeholder="中国"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="户名：" prop="accountName">
                                            <el-input id="accountName" class="redMark"   :maxlength="50" clearable size="mini" v-model.trim="bankForm.accountName" placeholder="张*"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="账号：" prop="bankAccount">
                                            <el-input id="bankAccount" class="redMark"   :maxlength="50" clearable size="mini" v-model.trim="bankForm.bankAccount" placeholder="开户行账号"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="开户行：" prop="openBank">
                                            <el-input id="openBank" class="redMark"   :maxlength="50" clearable size="mini" v-model.trim="bankForm.openBank" placeholder="中国**银行**支行"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="备注：" prop="remarks">
                                            <el-input id="remarks" class="redMark"   :maxlength="50" clearable size="mini" v-model.trim="bankForm.remarks" placeholder="请输入"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>

                        </section>
                    </div>
                    <div id="annex">
                        <div class="small-container">
                            <h3 class="tab-icon-fileList">附件清单<span class="tipss">带*的必须上传，供方在上传多页扫描件时合并后再上传</span></h3>
                            <div class="clearfix">
                                <el-form :model="mapAttachmentOptions" ref="annexForm" label-width="180px" class="annexForm" :disabled="editFlage == 0">
                                    <el-form-item v-for="(item,key) in mapAttachmentOptions"  :rules="{required: !(baseForm.monopolyFlag == 0 && key != 54), message:'请选择', trigger:'blur'}"
                                                  :key="key"
                                                  :prop="(key == 53 || key == 54 || key == 57 ) ? 'fileList' : ''"
                                                  :label="item.label+'：'">
                                        <page-upload :files="item.fileList"
                                                     :editFlag="true"
                                                     :attachmentType="key"></page-upload>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="账号密码" name="1">
                    <div id="register">
                        <section class="small-container">
                            <el-form :label-position="labelPosition" :rules="resetPasswordRules" :model="changePsForm" label-width="180px" status-icon ref="changePsFormRef">
                                <el-row>
                                    <el-col :span="12" style="margin-top:30px">
                                        <el-form-item label="账号：" prop="account" style="width:500px">
                                            <el-input type="text"   v-model.trim="changePsForm.account" placeholder="请输入账号或社会信用代码" clearable auto-complete="off"></el-input> 
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" style="margin-top:30px">
                                        <span style="float:left">
                                            账号以及统一社会信用代码都可以登录
                                        </span>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12" style="margin-top:30px">
                                        <el-form-item label="新密码：" prop="passwordNew" style="width:500px">
                                            <el-input type="password" v-model.trim="changePsForm.passwordNew" placeholder="请输入新密码" clearable auto-complete="off"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" style="margin-top:30px">
                                        <span style="float:left">
                                            6位，支持数字和英文字母
                                        </span>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12" style="margin-top:30px;margin-bottom:30px">
                                        <el-form-item label="确认新密码：" prop="resetPasswordNew" >
                                            <el-input type="password" style="width:280px" v-model.trim="changePsForm.resetPasswordNew" placeholder="请输入确认新密码" clearable auto-complete="off"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                
                            </el-form>
                        </section>
                    </div>
                </el-tab-pane>
                
            </el-tabs>
            <div style="margin: 0px 0 10px;" v-if="activeName == 0">
                <el-button v-if="editFlage == 1" type="primary" style="padding: 12px 50px;font-size: 16px;" @click="submitNew()" :loading="submitLoading" >完成提交</el-button>
            </div>
            <div style="margin: 0px 0 10px;" v-if="activeName == 1">
                <el-button type="primary" style="padding: 12px 50px;font-size: 16px;" @click="resetPassword()" :loading="submitLoading">确认</el-button>
            </div>
        </div>
         <select-category ref="selectCategory" @callback="selectedCategory" :categoryStatus="1"></select-category>
    </div>
</template>
<script type="text/babel">
    import MyHeader from './MasterHeader.vue';
    import { registerRules,naturalRules,contactRules,businessRules,numberRules,resetPasswordRules } from '../../util/rules';
    import { supplierTypeRules,annexRulesv,bankFormRules,baseRules,registerRules1,lastThreeAchieveRules,lastThreeFinanceRules } from '../../util/rules';
    export default {
        name: 'master-basicInfo',
        data() {
            return {
                changePsForm:{
                    account: "",
                    passwordNew: "",
                    resetPasswordNew: "",
                    supplierId: window.sessionStorage.getItem('loginId')
                },
                canSubmit:false,
                baseRules:baseRules,
                supplierTypeRules:supplierTypeRules,
                bankFormRules:bankFormRules,
                registerRules:registerRules1,
                lastThreeAchieveRules:lastThreeAchieveRules,
                lastThreeFinanceRules:lastThreeFinanceRules, 
                taxipayerOptions : [],//法人性质
                invoiceTypeOptions : [],//可开具发票性质
                categoryLevelOptions : [],//资质等级
                enterpriseNatureOptions:[],//企业性质
                taxRateTypeOptions:[],//可开发票税率
                resetPasswordRules:resetPasswordRules,
                endLoading: false,
                editFlage: '', //1 可以修改 0不可
                supplierCheckMarkVOList: [],//内网信息核验退回的标红字段id 集合
                areaInitCount: 0,//区域业绩初始化有几个意向投标区域，这几个只能看，不可删除
                labelPosition: 'right',//表单里的label定位
                baseForm:{
                    contractorName:'',//实际承包人姓名
                    linkSupplierName:'',//挂靠单位名称
                    contractorPhone:'',//实际承包人手机号码
                    contractorCard:'',//实际承包人身份证号码
                    account:'',//帐户信息
                    companyName :'',//供方名称
                    monopolyFlag :1,//是否垄断  （0 是 1 否）
                    socialCreditCode : '',//登录名
                    biddingArea: '',//可投标区域
                    superiorFlag:0,//是否有上级单位（0 是 1 否）
                    superiorCompanyName :'',//上级单位名称
                    countryName :'',//国家
                    cityName :'',//城市
                    linkMan:'',//联系人
                    linkManPost :'',//职务
                    linkPhone :'',//联系电话
                    recommender:'',//推荐人
                    headquartersAddress :'',//办公地址
                    companyEmail :'',//公司邮箱
                    /* 企业资质 */
                    qualificationsFlag :0,//是否有独立资质 (0 是 1 否)
                    enterpriseQualification :'',//企业资质
                    qualificationCertificate :'',//资质证书编号
                    qualificationReviewTime :'',//资质审核到期日
                    validityPeriodOfLicense :'',//安全许可证到期日
                    enterpriseCertification :'',//企业认证
                    /* 注册信息 */
                    legalRepresentative: '',//企业法人
                    registeredCapital : '',//注册资金
                    enterpriseNature:'',//企业性质
                    businessLicenseValidity: '2999-01-01 00:00:00',//营业执照有效期
                    businessLicenseStart:'',
                    invoiceType:'',//可开具发票性质
                    invoiceTypeId:'',//可开具发票性质名称
                    taxNumber :'',//税号
                    enterpriseRegistAddress:'',//注册地
                    invoiceTaxRate:'',//可开具发票税率
                    invoiceTaxRateList:[],//可开具发票税率
                    taxipayerStatus:'',//法人性质
                    taxipayerStatusId:'',//法人性质
                    businessScope :'',//企业经营范围
                },
                supplierTypeListForm:{
                    supplierTypeList:[
                    {
                        categoryId:'',//供方分类
                        categoryName:'',
                        levelId:'',//供方资质等级
                        levelName:'',//供方资质等级name
                        linkMan:'',//联系人
                        linkManPhone:'',//手机号码
                        delFlag:0,
                    }
                ],
                },
                supplierTypeList:[
                    {
                        categoryId:'',//供方分类
                        categoryName:'',
                        levelId:'',//供方资质等级
                        levelName:'',//供方资质等级name
                        linkMan:'',//联系人
                        linkManPhone:'',//手机号码
                        delFlag:0,
                    }
                ],
                lastThreeAchieveForm:{
                    lastThreeAchieveList:[
                    {
                        projectName:'',
                        contractAmount:'',
                        projectAddress:'',
                        contractSupplierName:'',
                        delFlag:0,
                    },{
                        projectName:'',
                        contractAmount:'',
                        projectAddress:'',
                        contractSupplierName:'',
                        delFlag:0,
                    },{
                        projectName:'',
                        contractAmount:'',
                        projectAddress:'',
                        contractSupplierName:'',
                        delFlag:0,
                    }],
                },
                lastThreeAchieveList:[
                {
                    projectName:'',
                    contractAmount:'',
                    projectAddress:'',
                    contractSupplierName:'',
                    delFlag:0,
                },{
                    projectName:'',
                    contractAmount:'',
                    projectAddress:'',
                    contractSupplierName:'',
                    delFlag:0,
                },{
                    projectName:'',
                    contractAmount:'',
                    projectAddress:'',
                    contractSupplierName:'',
                    delFlag:0,
                }],
                lastThreeFinanceList:[
                {
                    year:'',
                    revenue:'',
                    attachmentVOList:[],
                },
                {
                    year:'',
                    revenue:'',
                    attachmentVOList:[],
                },
                {
                    year:'',
                    revenue:'',
                    attachmentVOList:[],
                }],
                bankForm:{
                    country:'',//国家
                    accountName:'',//户名
                    bankAccount:'',//账号
                    openBank:'',//开户行
                    remarks:'',//备注
                },
                mapAttachmentOptions: {//附件清单
                    53: {
                        label: '供方类别资质文件',
                        fileList: []
                    },
                    54: {
                        label: '三证',
                        fileList: []
                    },
                    57: {
                        label: '业绩清单及合同附件',
                        fileList: []
                    },
                },
                currentSupplierIndex:-1,
                isHideNatural: true,//是否隐藏资质等级输入框；
                activeName: this.$route.params.entrance==999?'1':'0',//tabs切换名称；
                checked: true,//注册须知是否勾选了已阅读；
                tableData: [],//审核记录的数据
                submitLoading: false,//完成提交按钮加载中
            }
        },
        components: {
            MyHeader
        },
        created(){
            window.ellen = this;
            this.$root.activeIndex = 'invite';
            this.activeName = window.sessionStorage.getItem('activeNum') || '0';
            window.sessionStorage.setItem('activeNum','');
            let that = this;
            that.lastThreeAchieveForm.lastThreeAchieveList = that.lastThreeAchieveList;
            that.supplierTypeListForm.supplierTypeList = that.supplierTypeList;
            this.setRules();
            this.getAllInfoNew();//获取所有
        },
        mounted(){
            this.getType('taxipayer_status');//法人性质
            this.getType('invoice_type');//可开具发票性质
            this.getType('category_level');//资质等级
            this.getType('enterprise_nature');//企业性质
            this.getType('tax_rate_type');//可开发票率 
        },
        methods: {
            resetPassword(){
                let that = this;
                that.submitLoading = true;
                that.$refs['changePsFormRef'].validate((valid) => {
                    if (valid) {
                        that.$root.postHttp('/v1/login/public/changePassword',that.changePsForm,function(res){
                            that.submitLoading = false;
                            that.$alert('账号密码设置成功!  您可以使用账号或社会信用代码，用新的密码进行登录', '提示', {
                                confirmButtonText: '确定',
                                type: 'success',
                                callback: action => {
                                    window.sessionStorage.clear();
                                    that.$router.push('/login/masterCenter');
                                    that.$root.isLogin = false;
                                }
                            });
                        },function(){
                            that.submitLoading = false;
                       })
                         
                    }else {
                        that.submitLoading = false;
                        return false;
                    }
                });
                
            },
          
            getAllInfoNew(){
                let _this = this;
                _this.$root.loading = true;
                _this.$root.getHttp('/v1/outerformflow/outerGetSupplierById/'+ window.sessionStorage.getItem('loginId'),function(res){
                    _this.$root.loading = false;
                    _this.endLoading = true;
                    // _this.editFlage = res.data.data.editFlage; //是否可以提交  1 可以 0不可
                    //_this.editFlage = 0;//按照黄凯要求，外网暂时统一不可修改 20210705
                    _this.editFlage = 1;//按照黄凯要求，外网放开
                    _this.baseForm = res.data.data.supplierVO;
                    _this.changePsForm.account = res.data.data.supplierVO.account;
                    if(_this.baseForm.contractorId){
                        _this.isLinkSupplier = true;
                    }
                    if(res.data.data.supplierVO.invoiceTaxRate){
                        _this.baseForm.invoiceTaxRateList = res.data.data.supplierVO.invoiceTaxRate.split(',') ;
                    }
                    _this.baseForm.invoiceType = res.data.data.supplierVO.invoiceType+'';
                    //_this.baseForm.invoiceType = _this.$root.getDictListByType('invoice_type',res.data.data.supplierVO.invoiceType,'0').dictLabel;
                    _this.baseForm.taxipayerStatus = res.data.data.supplierVO.taxipayerStatus+'';
                   // _this.baseForm.taxipayerStatus = _this.$root.getDictListByType('taxipayer_status',res.data.data.supplierVO.taxipayerStatus,'0').dictLabel; 
                    _this.baseForm.enterpriseNatureId = res.data.data.supplierVO.enterpriseNature;
                    //_this.baseForm.enterpriseNature = _this.$root.getDictListByType('enterprise_nature',res.data.data.supplierVO.enterpriseNature,'').dictLabel;
                    _this.supplierTypeList = res.data.data.supplierSplitVOList||[];
                    _this.supplierTypeListForm.supplierTypeList = _this.supplierTypeList;
                    _this.lastThreeAchieveList = res.data.data.supplierAchievementInfoList||[];
                    _this.lastThreeAchieveForm.lastThreeAchieveList = _this.lastThreeAchieveList;
                    console.log(6666,_this.lastThreeAchieveList,77,_this.lastThreeAchieveForm.lastThreeAchieveList)
                    _this.lastThreeFinanceList = res.data.data.supplierFinanceInfoVOList||[];
                    console.log(1111,_this.lastThreeFinanceList)
                    _this.bankForm = res.data.data.supplierBankInfo;
                    _this.mapAttachmentOptions[53].fileList = res.data.data.attachmentVOList2;
                    _this.mapAttachmentOptions[54].fileList = res.data.data.attachmentVOList3;
                    _this.mapAttachmentOptions[57].fileList = res.data.data.attachmentVOList4; 
                    /*审批历程数据;*/
                        // _this.tableData = res.data.confirmHistoryVOs || [];
                    _this.tableDataOA = res.data.baseApprovalRecordVOs || [];
                    if(_this.tableDataOA.length){
                        _this.tableDataOA.forEach( (item,i) => {
                            item.approveStatusName = _this.$root.getDictListByType('approve_status',item.approveStatus).dictLabel;
                        })
                    }
                });
            },
            chooseCategory(index){
                this.currentSupplierIndex = index;
                this.$refs['selectCategory'].show();
            },
            selectedCategory(val){
                this.supplierTypeList[this.currentSupplierIndex].categoryId = val.id;
                this.supplierTypeList[this.currentSupplierIndex].categoryName = val.categoryName;
                this.supplierTypeListForm.supplierTypeList = this.supplierTypeList;
            },
            addSupplierType(){
                this.supplierTypeList.unshift(
                    {
                        categoryId:'',//供方分类
                        categoryName:'',
                        levelId:'',//供方资质等级
                        levelName:'',//供方资质等级name
                        linkMan:'',//联系人
                        linkManPhone:'',//手机号码
                        delFlag:1,
                    }
                );
                this.supplierTypeListForm.supplierTypeList = this.supplierTypeList;
            },
            removeSupplierType(index){
                this.supplierTypeList.splice(index,1);
                this.supplierTypeListForm.supplierTypeList = this.supplierTypeList;
            },
            addLastThreeAchieve(){
                if(this.lastThreeAchieveList.length>2){
                    this.lastThreeAchieveList.unshift(
                        {
                            contractAmount:'',
                            contractMoney:'',
                            projectAddress:'',
                            contractSupplierName:'',
                            delFlag:1,
                        }
                    );
                }else{
                    this.lastThreeAchieveList.unshift(
                        {
                            contractAmount:'',
                            contractMoney:'',
                            projectAddress:'',
                            contractSupplierName:'',
                            delFlag:0,
                        }
                    );
                }
                this.lastThreeAchieveForm.lastThreeAchieveList = this.lastThreeAchieveList;
            },
            removeLastThreeAchieve(index){
                this.lastThreeAchieveList.splice(index,1);
                this.lastThreeAchieveForm.lastThreeAchieveList = this.lastThreeAchieveList;
            },
            addLastThreeFinance(){
                this.lastThreeFinanceList.unshift(
                    {
                        year:'',
                        revenue:'',
                        attachmentVOList:[],
                    }
                );

            },
            removeLastThreeFinance(index){
                this.lastThreeFinanceList.splice(index,1);
            },
            lastThreeFinanceItemFile(){
                this.lastThreeFinanceList.forEach((item,i) => {
                    var form = 'lastThreeFinanceItem'+i;
                    if(this.$refs[form][0]){this.$refs[form][0].clearValidate();}
                });
            },
            getType(type){
                let _this = this;
                _this.$root.getHttp('v1/sysDict/public/getDictListByDictType?dictType='+type,function(res){
                    if(type == 'taxipayer_status'){
                        _this.taxipayerOptions  = res.data.data;//法人性质
                    } else if(type == 'category_level'){
                        _this.categoryLevelOptions  = res.data.data;//供方资质等级
                    }else if(type == 'invoice_type'){
                        _this.invoiceTypeOptions  = res.data.data;//可开具发票性质
                    }else if(type == 'enterprise_nature'){
                        _this.enterpriseNatureOptions  = res.data.data;//企业性质
                    }else if(type == 'tax_rate_type'){
                        _this.taxRateTypeOptions  = res.data.data;//税率
                    }
                });
            },
            setRules(){
                var obj = {
                    userName: [//登录手机号
                        { required: true, message: ' '},
                        { validator: 'regexp', pattern: /^[1][0-9][0-9]{9}$/, message: '手机号码格式不正确', trigger: 'blur'},
                        { validator: this.checkMobile, trigger: 'blur'}
                    ],
                    socialCreditCode:[
                        {required: true, message: ' '},
                        { validator: 'regexp',pattern: /^[A-Za-z0-9]{18}$/,message: '18位数字或字母', trigger: 'blur'},
                    { validator: this.checkSocialCode, trigger: 'blur'}
                    ],
                    businessLicenseNumber:[
                        {required: true, message: ' '},
                        { validator: 'regexp',pattern: /^[A-Za-z0-9]{13,18}$/,message: '13-18位数字或字母', trigger: 'blur'},
                    { validator: this.checkSocialCode, trigger: 'blur'}
                    ]
                };
                let obj2 = {
                    contactPersonMobile:[
                        {required: true, message: ' '},
                        { validator: 'regexp', pattern: /^[1][0-9][0-9]{9}$/, message: '手机号码格式不正确', trigger: 'blur'},
                        { validator: this.checkMobile, trigger: 'blur'}
                    ],
                };
                this.contactRules = Object.assign(obj2,this.contactRules); //意向投标区域联系人校验

                let obj4 ={
                    enterpriseQualification:[
                        {required: true, message: ' ',trigger:'blur'},
                    ],
                    qualificationsFlag:[
                        {required: true, message: ' ',trigger:'change'}
                    ],
                }
                this.qiYeZiZhiRules = Object.assign(obj4,this.qiYeZiZhiRules);//基础信息校验

                let obj3 = {
                    companyName: [
                        {required: true, message: ' ', trigger: 'blur'},
                        { validator: this.checkBaseCompanyName,message: '需与企业工商注册信息一致',trigger: 'blur'}
                    ],
                }
                this.baseRules = Object.assign(obj3,this.baseRules);
            },
            changeInvoiceType(){
                if(this.baseForm.invoiceType){
                    this.$refs.registerForm.clearValidate("invoiceType");
                }
            },
            changeSuperiorFlag(){
                if(this.baseForm.superiorFlag!='0'){
                    this.$refs.baseForm.clearValidate("superiorCompanyName");
                }
            },
            changeTaxipayerStatus(){
                if(this.baseForm.taxipayerStatus){
                    this.$refs.registerForm.clearValidate("taxipayerStatus");
                }
            },
            //校验社会信用代码
            checkSocialCode(code){
                var myreg= /^[0-9a-zA-Z]+$/;
                console.log(code.length)
                if (code.length != 18 || !myreg.test(code)) {
                    this.$alert('请输入正确的社会信用代码！',{
                        type:'warning'
                    });
                    this.baseForm.socialCreditCode = ""
                }
            },
            checkCompanyName(rule,value,callback){//校验企业名称唯一性
                this.$root.getHttp('/v1/sSuppliers/public/checkCompanyName/'+value+'/null',function(res){
                    if(res.data.code == 1){
                        callback();
                    } else {
                        callback(new Error(res.data.msg));
                    }
                });
            },
            checkMobile(rule,value,callback){//校验登录账号手机号
                this.$root.getHttp('/v1/sSuppliers/public/checkPhone/'+value,function(res){
                    if(res.data.code == 1){
                        callback();
                    } else {
                        callback(new Error(res.data.msg));
                    }
                });
            },
            //校验手机号码
            checkPhone(phone,type,index){
                console.log(phone)
                var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
                if (!myreg.test(phone)) {
                    this.$alert('请输入正确的手机号码！',{
                        type:'warning'
                    });
                    if(type == 1){
                        this.baseForm.linkPhone = ""
                    }else{
                        this.supplierTypeList[index].linkManPhone = ""
                    }
                }
                this.supplierTypeListForm.supplierTypeList = this.supplierTypeList;
            },
            //校验邮箱
            checkEmail(email){
                var myreg=/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
                if (!myreg.test(email)) {
                    this.$alert('请输入正确的邮箱！',{
                        type:'warning'
                    });
                    this.baseForm.companyEmail = ""
                }
            },
            checkNumber(index=0,type,s){
                let that = this;
                let reg = /(^[1-9]\d*$)/;
                if (!reg.test(s)) {
                    that.$alert('请输入正整数！',{
                        type:'warning'
                    });
                    if(type==1){
                        that.lastThreeFinanceList[index].revenue = '';
                    }else if(type==2){
                        that.lastThreeFinanceList[index].year = '';
                    }else if(type==3){
                        that.lastThreeAchieveList[index].contractAmount = '';
                    }else if(type==4){
                        that.baseForm.registeredCapital = '';
                    }else if(type==5){
                        that.baseForm.invoiceTaxRate = '';
                    }
                }
                that.lastThreeAchieveForm.lastThreeAchieveList = that.lastThreeAchieveList;
            },
            //校验整数或两位小数
            checkNumberDot(index=0,type,s){
                let that = this;
                let reg = /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,8}\.\d{0,2}$|^[1-9]\d{0,8}$/;
                if (!reg.test(s)) {
                    that.$alert('请输入有效金额！',{
                        type:'warning'
                    });
                    if(type==1){
                        that.lastThreeFinanceList[index].revenue = '';
                    }else if(type==2){
                        that.lastThreeFinanceList[index].year = '';
                    }else if(type==3){
                        that.lastThreeAchieveList[index].contractAmount = '';
                    }else if(type==4){
                        that.baseForm.registeredCapital = '';
                    }else if(type==5){
                        that.baseForm.invoiceTaxRate = '';
                    }
                }
                that.lastThreeAchieveForm.lastThreeAchieveList = that.lastThreeAchieveList;
            },
            checkRegisterNumberDotNew(s){
                let that = this;
                let reg = /(^[0-9]([0-9]+)?(\.[0-9]{1,6})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
                if (!reg.test(s)) {
                    that.$alert('请输入有效金额！',{
                        type:'warning'
                    });
                    
                    that.baseForm.registeredCapital = '';
                   
                }
                that.lastThreeAchieveForm.lastThreeAchieveList = that.lastThreeAchieveList;
            },
           
            handleClick(tab, event) {//tabs标签页切换
            },
            submitNew(){
                var _this = this;
                _this.submitLoading = true;
                //整个表单验证
                _this.valid_first().then(res => {
                    _this.submit(res);
                });
            },
            valid_first(){
                var _this = this;
                /* 基础信息、银行信息 */
                var arr_first = ['baseForm','bankForm'];
                /* 注册信息 */
                if(_this.baseForm.monopolyFlag!=0){
                    arr_first.push('registerForm');
                    arr_first.push('lastThreeAchieveFrom');
                    arr_first.push('supplierTypeListRef');
                    var naturalFormArr = [];
                    _this.lastThreeFinanceList.forEach((item,i) => {
                        naturalFormArr.push('lastThreeFinanceItem'+i)
                    });
                    arr_first = arr_first.concat(naturalFormArr);
                }
                /* 企业资质 */
                if(_this.baseForm.qualificationsFlag ==0){
                    arr_first.push('qiYeZiZhiForm');
                }
                return Promise.all(arr_first.map(form=>{
                    const _form = _this.$refs[form][0] || _this.$refs[form];
                    return _form.validate()
                })).then(args=>{
                    _this.canSubmit = true;
                     //console.log(_this.canSubmit,1233445 )
                    return true;
                    //!!fn && fn();
                }).catch(err =>{
                    _this.canSubmit = false;
                    _this.submitLoading = false;
                    _this.$alert('请把带*的必填字段填写完整', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                    //console.log(_this.canSubmit,666666 )
                    //console.log('err')
                    return false;
                })
            },
            submit(){
                var _this = this;
                if(!_this.canSubmit){
                    _this.submitLoading = false;
                    return;
                }
                for(var i in _this.mapAttachmentOptions) {
                    if(!(this.baseForm.monopolyFlag == 0 && i != 54)){
                        if(!_this.mapAttachmentOptions[i].fileList.length>0) {
                            _this.$alert('带*的附件必须上传', '提示', {
                                confirmButtonText: '确定',
                                type: 'warning'
                            });
                            _this.canSubmit = false;
                            _this.submitLoading = false;
                            return;
                        }
                    }
                }
                _this.submitData();
            },
            submitData(){
                let _this = this;
                if(_this.baseForm.invoiceTaxRateList && _this.baseForm.invoiceTaxRateList.length>0){
                    _this.baseForm.invoiceTaxRate = _this.baseForm.invoiceTaxRateList.join(',');
                }
                var formParams = {
                    "supplierVO":_this.baseForm,//基本信息
                    "supplierSplitVOList":_this.supplierTypeList,//供方分类
                    "supplierAchievementInfoList": _this.lastThreeAchieveList,//近三年业绩
                    "supplierFinanceInfoVOList":_this.lastThreeFinanceList,//近三年财务情况
                    "supplierBankInfo":_this.bankForm,//银行信息
                    "attachmentVOList2":_this.mapAttachmentOptions[53].fileList,//附件清单-供方类别资质文件
                    "attachmentVOList3":_this.mapAttachmentOptions[54].fileList,//附件清单-三证
                    "attachmentVOList4":_this.mapAttachmentOptions[57].fileList,// 附件清单-业绩清单及合同附件
                };
                console.log('校验通过了',formParams)
                _this.$root.postHttp('/v1/outerformflow/outerUpdateSupplier',formParams,function(res){
                    _this.submitLoading = false;
                    _this.$alert('修改成功', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {
                           window.location.reload();
                        }
                    });
                },function(){
                    _this.submitLoading = false;
                }) 
            },
        }
    }
</script>
<style lang="scss">
    @import "../../assets/var";
    dl {
        margin: 0;
    }
    a {
        text-decoration: none;
    }
    /*banner*/
    .banner {
        /*margin-top: 80px;*/
        margin-bottom: 20px;
        & img {
            width: 100%;
            min-width:1300px;
            height: 140px;
        }
    }
    #basicInfo {
        padding: 80px 0;
        min-height: 85vh;
        background: $--primary-fill-color;
        & .head-top{
            background: #fff;
        }
        .basicMain {
            background: #fff;
            padding: 0px 0 30px;
        }
        /*审核记录，表格*/
        .recordTable {
            & th {
                text-align: center;
            }
            .el-table__body tr.current-row > td {
                background-color: #ebeef5;
            }
        }
        //审核记录弹出层表格
        .tableInfo {
            font-family: '宋体';
            th {
                text-align: center;
            }
            .el-table .cell {
                white-space: nowrap;
            }
            .tipStyle {
                width: 200px;
                white-space: normal;
            }
        }
        input,
        textarea,
        .el-cascader__label,
        .el-radio__label {
            color: $--text-color;
        }
        input::-webkit-input-placeholder{
            color: #c0c4cc;
        }
        input::-moz-placeholder{   /* Mozilla Firefox 19+ */
            color: #c0c4cc;
        }
        input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
            color: #c0c4cc;
        }
        input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
            color: #c0c4cc;
        }
    }
    #register {
        padding-bottom: 30px;
    }
    .el-pagination {
        margin:30px 0 40px;
    }
    /*注册须知*/
    #article {
        & .el-dialog {
            border-radius: 15px;
        }
        & .el-dialog__header {
            text-align: left;
            font-weight: bold;
            border-bottom: 1px solid $--text-color-light;
        }
        .el-dialog__title {
            padding-left: 30px;
            background: url('../../assets/images/register/icon_tit.png') no-repeat 0 1px;
        }
        .el-dialog--center .el-dialog__body {
            height: 320px;
            overflow-y: scroll;
        }
        & .center {
            text-align: center;
        }
        & section {
            margin-top: 15px;
            padding: 10px;
            color: $--primary-color;
            border: 1px solid $--secondary-fill-color;
        }
        & .padd {
            padding: 5px 0;
        }
        & .indent {
            text-indent: 28px;
        }
        & .indent2 {
            text-indent: 38px;
            /*padding: 0 14px;*/
        }
        & .readed {
            /*margin-top: 20px;*/
            padding: 15px;
            border-top: 1px dashed $--text-color-lighter;
            text-align: left;
        }
        & .el-button{
            padding: 10px 36px;
        }
        & .disagree {
            background: $--text-color-lighter;
            border: none;
        }
        & .el-dialog__footer {
            padding: 0 20px 20px;
        }
    }
    /*tab切换*/
    #basicInfo .el-tabs {
        padding-top: 10px;
        & .el-tabs__header {
            margin: 0 0 30px;
        }
        & .el-tabs__nav {
            margin-left: 40px;
        }
        & .el-tabs__item {
            font-size: 14px;
            height: 50px;
        }
        & .el-tabs__item.is-active {
            color: $--text-color;
            font-weight: 700;
        }
        & .el-tabs__active-bar {
            bottom: -2px;
            height: 12px;
            background: url('../../assets/images/register/at.png') no-repeat center 0;
        }
        & .el-tabs__nav-wrap::after {
            height: 1px;
            background-color: $--secondary-fill-color;
        }
    }
    #basicInfo .small-container {
        width: 1120px;
        margin: 0 auto 15px;
        padding-bottom: 15px;
        .returnText {
            margin-bottom:0;
            color: #cb1235;
            font-family: '宋体';
        }
        /*box-shadow: 0 0 2px;*/
        & form {
            width: 95%;
            margin: 0 auto;
            & .el-form-item__label {
                padding: 0 5px 0 0;
                color: #333;
            }
            & .el-form-item__content {
                width: 56%;
                text-align: left;
                background: #fff;
                & .el-select {
                    /*width: 35%;*/
                }
            }

            & .contentFull .el-form-item__content{
                width: 80%;
            }
            & .selectFull .el-select {
                width: 100%;
            }
            .time .el-form-item__content {
                width: 61%;
            }
            & .time .el-date-editor.el-input {
                width: 90%;
            }
            & .validity .el-form-item__content {
                width: 100%;
            }
            & .unit {
                width: 85%;
                margin-right: 10px;
            }
            & .capital .el-form-item__content {
                width: 80%;
            }
            & .capital .unit {
                width: 28%;
            }
            & .veriCodeItem {
                position: relative;
                & input {
                    width: 60%;
                }
                & button {
                    position: absolute;
                    right: 0px;
                    top: 2px;
                }
                & .el-input__suffix {
                    right: 130px;
                }
            }
            & .creditCode,
            & .companyNature {
                position: relative;
                & .el-form-item__content>.el-input {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 180px;
                }
            }
            & .creditCode {
                .el-form-item__content {
                    width:100%;
                }
                & .el-form-item__content>.el-input {
                    width: 220px;
                    right: 560px;
                }
                .tip {
                    margin-left: 250px;
                }
                & .el-form-item__error {
                    left: 30%;
                }
            }
            & .companyNature {
                & .el-form-item__content>.el-input {
                    right: 250px;
                }
            }
            .capitalAddrWrap {
                .el-form-item__content {
                    position: relative;
                    .capitalAddr {
                        position: absolute;
                        left: 0;
                    }
                    .cityAdd {
                        left: 160px;
                    }
                    .addressAdd {
                        left: 320px;
                    }
                }
            }
            & .capitalAddr .el-form-item__content {
                width: 100%;
                &>.el-input {
                    width: 100%;
                    position: relative;
                }
                .el-select {
                    width: 150px;
                }
               /* .el-form-item__error {
                    left: 42%;
                }*/
            }
        }
        & .naturalForm  {
            padding: 5px 20px 0px;
            & .el-form-item__label {
                padding: 0;
            }
            & .el-form-item__content {
                width: 60%;
            }
        }
        & .naturalForm2 {
            border: none;
            border-top: 1px dashed #dcdfe6;
            margin: 5px auto;
            padding: 5px 20px 0px;
        }
        & .naturalForm3  {
            & .el-form-item__label {
                padding: 0;
            }
            & .el-form-item__content {
                width: 50%;
            }
            border: 1px dashed #dcdfe6;
            margin: 5px auto;
        }
        & .naturalForm4  {
            padding: 5px 20px 0px;
            .el-form-item__content{
                width: 60%;
            }
			#attachmentCol{
                .el-form-item__content{
                    width: 70%;
                } 
            }
            .add.dele {
                margin-right: 15px;
            }

        }
        & .naturalForm5  {
            .naturalForm5Text{
                font-size: 11px;
            }
            & .el-form-item__label {
                padding: 0;
            }
            & .el-form-item__content {
                width: 100%;
                text-align: center;
                font-size: 10px;
                line-height: 35px;
            }
            border: 1px dashed #dcdfe6;
            margin: 5px auto;
        }
        & .bankForm  {
            padding: 5px 20px 0px;
            .el-form-item__content{
                width: 60%;
                & .el-input {
                    width: 80%;
                }
            }
        }
        .el-cascader--medium {
            width: 100%;
        }
        & h3,
        & h4{
            margin-bottom: 15px;
            padding: 0 30px;
            text-align: left;
            line-height: 50px;
            color: $--text-color-light;
            background: $--secondary-fill-color;
            overflow: hidden;
        }
        & h4 {
            text-indent: 10px;
            line-height: 35px;
            background: $--primary-fill-color;
        }
        & .areaCooperationAchievementVOList {
            margin-top: 0;
            & h3 {
                margin: 0 0 30px;
            }
            & .tips {
                margin-right: 20px;
            }
        }
        & .tip {
            margin-left: 10px;
            color: $--primary-color;
            font-size: 12px;
        }
        & .tips {
            float: right;
            padding-left: 20px;
            font-weight: normal;
            font-size: 12px;
            color: $--text-color-lighter;
            background: url('../../assets/images/register/icon03.png') no-repeat left center;
        }
        & .add {
            float: right;
            font-size: 14px;
            cursor: pointer;
            & img {
                vertical-align: middle;
                width: 70px;
                height: 26px;
            }
        }
        .openS img {
            width: 25px;
            height: 25px;
        }
        .add.dele {
            margin-right: 30px;
        }
        & .dele img {
            transform: scale(1);
            transition: .5s;
            width: 34px;
            height: 34px;
        }
        .dele:hover img {
            transform: scale(1.1);
        }
        & .remarks {
            width: 95%;
        }
    }
    #register .small-container,
    #annex .small-container {
        box-shadow: 0 0 2px;
    }
    #register,
    #annex {
        padding: 2px 0;
    }
    .uploadAnnex {
        overflow: hidden;
        & .el-upload {
            float: left;
        }
        & .el-upload-list {
            float: left;
            margin-left: 5px;
        }
        &>button {
            float: right;
            /*margin-right: 20px;*/
        }
    }
    #achievement {
        padding: 2px 0;
        .return {
            padding-bottom: 0;
            position:relative;
            box-shadow: 0 0 2px;
        }
        .small-container {
            form .unit {
                width: 85%;
                margin-right: 10px;
            }
        }
    }
    #basicInfo {
        .el-form-item {
            margin-bottom: 0px; 
        }
        .file-list{
            float: left;
        }
        .el-upload{
            float: right;
        }
        .small-container {
            .redElement {
                background: $--primary-color;
                color: #fff;
                .el-radio__input.is-checked + .el-radio__label,
                .el-radio__label{
                    color: #fff;
                }
                .el-radio__input.is-checked .el-radio__inner{
                    border-color: #fff;
                }            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/master/BasicInfoNew.vue